import { render, staticRenderFns } from "./EmergencyWarningPage.vue?vue&type=template&id=621da2fe&"
import script from "./EmergencyWarningPage.vue?vue&type=script&lang=js&"
export * from "./EmergencyWarningPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports